import { createSlice } from '@reduxjs/toolkit';

const user = createSlice({
    name: 'user',
    initialState: {
        firstname: '',
        lastname: '',
        roles: [],
        username: '',
        email: '',
        status_id: '',
        contact_phone: '',
        school_name: '',
        parents: [],
        activeRole:''
    },
    reducers: {
        setName(state,action) {
          state.firstname = action.payload.firstname
          state.lastname = action.payload.lastname
        },
        setActiveRole(state, action) {
            state.activeRole = action.payload
        },
        removeRole(state) {
            state.activeRole = '';
        },
        setUser(state,action) {
            const { firstname, lastname, roles, username, email, status_id, contact_phone, school_name, parents, activeRole } = action.payload;
            state.firstname = firstname;
            state.lastname = lastname;
            state.roles = roles;
            state.username = username;
            state.email = email;
            state.status_id = status_id;
            state.contact_phone = contact_phone;
            state.school_name = school_name;
            state.parents = parents;
            state.activeRole = activeRole
        },
        clearUser(state, action){
            state.firstname = '';
            state.lastname = '';
            state.roles = [];
            state.username = '';
            state.email = '';
            state.status_id = '';
            state.contact_phone = '';
            state.school_name = '';
            state.parents = [];
            state.activeRole = '';
        }
    }
})

export default user.reducer

export const {setName, setActiveRole, removeRole, setUser, clearUser } = user.actions;
